import React from "react";
import { Tooltip } from "antd";

const TopFilterBarLandscape = ({
  locationField,
  dateRangeField,
  partyField,
  searchBar,
}) => {
  return (
    <div
      style={{
        width: "100%",
        backgroundColor: "white",
        maxWidth: "98vw",
        overflow: "hidden",
      }}
    >
      <div style={{ width: "100%", height: "2.5rem" }}></div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
          // gap: "0.5rem",
          position: "fixed",
          top: "4rem",
          zIndex: 999,
          backgroundColor: "white",
          paddingBottom: "0.5rem",
          maxWidth: "98vw",
          marginLeft: "auto",
          marginRight: "auto",
        }}
      >
        <div
          style={{
            width: "1.5rem",
            height: "1.5rem",
            minWidth: "1.5rem",
          }}
        ></div>
        <div
          style={{
            flex: 1,
            // marginTop: "0.5rem",
          }}
        >
          <Tooltip
            title="Destination"
            style={{
              width: "100%",
              backgroundColor: "transparent",
              padding: 0,
              border: "none",
              margin: 0,
            }}
          >
            {locationField}
          </Tooltip>
        </div>
        <div
          style={{
            width: "0.5rem",
            height: "0.5rem",
            minWidth: "0.5rem",
          }}
        ></div>
        <div
          style={{
            flex: 1,
          }}
        >
          <Tooltip
            title="Travel Dates"
            style={{
              width: "100%",
              backgroundColor: "transparent",
              padding: 0,
              border: "none",
              margin: 0,
            }}
          >
            {dateRangeField}
          </Tooltip>
        </div>
        <div
          style={{
            width: "0.5rem",
            height: "0.5rem",
            minWidth: "0.5rem",
          }}
        ></div>
        <div
          style={{
            // flex: 1,
            minWidth: "8rem",
          }}
        >
          <Tooltip
            title="Party Details"
            style={{
              width: "100%",
              backgroundColor: "transparent",
              padding: 0,
              border: "none",
              margin: 0,
            }}
          >
            {partyField}
          </Tooltip>
        </div>
        <div
          style={{
            width: "0.5rem",
            height: "0.5rem",
            minWidth: "0.5rem",
          }}
        ></div>
        <div
          style={
            {
              // flex: 1,
            }
          }
        >
          {searchBar}
        </div>
        <div
          style={{
            width: "1.5rem",
            height: "1.5rem",
            minWidth: "1.5rem",
          }}
        ></div>
      </div>
    </div>
  );
};

export default TopFilterBarLandscape;